export const Logo = ({ onClick }) => (
  <a
    href="#top"
    data-testid="logo-link"
    onClick={(e) => {
      e.preventDefault();
      onClick ? onClick() : window.scrollTo({ top: 0, behavior: "smooth" });
    }}
    className="flex items-center gap-3 group"
  >
    <img
      src="/logo-rk.png"
      alt="RK Tourism & Travels logo"
      className="w-14 h-14 rounded-full object-cover ring-1 ring-[#d4af37]/60 transition-transform duration-500 group-hover:scale-105"
    />
    <div className="leading-none whitespace-nowrap">
      <span className="block font-display text-lg tracking-[0.2em] text-slate-50">
        RK TOURISM
      </span>
      <span className="block text-[10px] tracking-[0.45em] text-[#d4af37] mt-1">
        & TRAVELS
      </span>
    </div>
  </a>
);
